var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 544,
    viewBox: "0 0 1440 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1323",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1441,
    height: 544
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1441,
    height: 544,
    rx: 35,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1323)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-37.6571 -734.842L-41.4384 770.088C-41.487 789.418 -25.8564 805.125 -6.52651 805.17L1406.52 808.501C1425.85 808.546 1441.56 792.913 1441.61 773.583L1445.39 -731.347C1445.44 -750.676 1429.81 -766.383 1410.48 -766.429L-2.56924 -769.76C-21.8991 -769.805 -37.6085 -754.172 -37.6571 -734.842Z",
    fill: "url(#paint0_radial_1_1323)",
    fillOpacity: 0.97
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-39.1988 -736.519L-42.9882 771.725C-43.0368 791.055 -27.4062 806.762 -8.07627 806.808L1408.06 810.146C1427.39 810.191 1443.1 794.558 1443.15 775.229L1446.94 -733.016C1446.99 -752.346 1431.36 -768.053 1412.03 -768.098L-4.11096 -771.436C-23.4409 -771.482 -39.1502 -755.849 -39.1988 -736.519Z",
    fill: "url(#paint1_radial_1_1323)",
    fillOpacity: 0.84
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M-39.1988 -736.519L-42.9882 771.725C-43.0368 791.055 -27.4062 806.762 -8.07627 806.808L1408.06 810.146C1427.39 810.191 1443.1 794.558 1443.15 775.229L1446.94 -733.016C1446.99 -752.346 1431.36 -768.053 1412.03 -768.098L-4.11096 -771.436C-23.4409 -771.482 -39.1502 -755.849 -39.1988 -736.519Z",
    fill: "url(#paint2_radial_1_1323)",
    fillOpacity: 0.92
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_1323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -43,
    y: -772,
    width: 1490,
    height: 1583
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-38.634 -736.519L-42.9754 771.31C-43.0311 790.64 -27.4062 806.351 -8.07632 806.402L1407.48 810.136C1426.81 810.187 1442.53 794.558 1442.58 775.229L1446.93 -732.6C1446.98 -751.93 1431.36 -767.641 1412.03 -767.692L-3.53334 -771.426C-22.8632 -771.477 -38.5783 -755.848 -38.634 -736.519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_1323)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M942.29 61.4371C922.051 73.9021 895.548 63.0091 889.937 39.919L847.447 -134.93C847.25 -135.769 848.077 -136.484 848.879 -136.168L1036.28 -62.1727C1063.09 -51.5872 1066.31 -14.9394 1041.75 0.181258L942.29 61.4371ZM891.23 36.6078C896.839 59.6998 923.343 70.5944 943.584 58.1284L1037.03 0.575283C1061.58 -14.5456 1058.37 -51.1931 1031.56 -61.7785L912.731 -108.697C886.338 -119.118 859.153 -95.439 865.851 -67.8639L891.23 36.6078Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M965.042 192.091C964.065 191.505 963.721 190.255 964.26 189.25L993.633 134.546L1097.77 -35.9188C1098.08 -36.4292 1098.76 -36.5742 1099.25 -36.2366C1099.7 -35.9259 1099.84 -35.3161 1099.56 -34.8426L965.086 192.066C965.077 192.081 965.06 192.091 965.042 192.091ZM1020.2 94.9437C1020.2 94.9452 1020.2 94.9466 1020.2 94.9479L995.318 135.656L988.122 149.04L1020.18 94.9396C1020.19 94.9327 1020.2 94.9356 1020.2 94.9437Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M964.863 192.125C964.476 192.786 963.521 192.784 963.137 192.122L901.393 85.7515C901.096 85.2217 901.27 84.5521 901.787 84.2334L1097.71 -36.5377C1098.25 -36.8677 1098.94 -36.767 1099.36 -36.2987C1099.74 -35.8764 1099.8 -35.2577 1099.51 -34.7701L964.863 192.125ZM934.084 137.964C947.494 161.072 980.815 161.222 994.455 138.236L1023.57 89.1732C1042.24 57.7199 1006.25 22.3386 975.117 41.5313L932.703 67.6778C916.551 77.6349 911.265 98.6435 920.785 115.048L934.084 137.964Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.93 455.462C1107.4 455.727 1106.76 455.526 1106.48 455.007L964.016 192.572C963.92 192.395 963.98 192.173 964.152 192.069C964.392 191.924 964.396 191.577 964.158 191.428L964.131 191.411C963.955 191.3 963.895 191.072 963.993 190.888L972.96 174.174C981.477 158.298 1004.79 160.08 1010.78 177.066L1108.47 454.12C1108.66 454.639 1108.42 455.215 1107.93 455.462ZM965.889 191.741C965.889 191.737 965.895 191.736 965.897 191.74L998.23 251.297C1008.43 270.079 1036.96 257.39 1029.85 237.234L1002.13 158.642C999.316 150.661 988.361 149.826 984.363 157.287L965.897 191.743C965.895 191.747 965.889 191.746 965.889 191.741Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M936.371 473.699L963.648 191.703C963.751 190.696 965.093 190.427 965.576 191.316L1108.85 454.887C1109.23 455.559 1108.79 456.396 1108.02 456.472L936.403 473.664C936.385 473.666 936.371 473.681 936.371 473.699ZM938.633 471.278C938.633 471.294 938.648 471.308 938.665 471.306L1053.86 459.758C1078.76 457.261 1093.09 430.191 1081.14 408.205L1019.93 295.612C1003.45 265.293 957.667 274.627 954.342 308.983L938.633 471.278Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.63 732.277C1054.64 732.274 1054.63 732.271 1054.63 732.273L1053.1 733.263C1052.93 733.369 1052.72 733.225 1052.76 733.033L1090.84 541.203C1097.06 509.861 1138.57 502.54 1155.11 529.867L1214.42 627.837C1214.73 628.367 1214.57 629.049 1214.05 629.383L1054.64 732.281C1054.63 732.282 1054.63 732.279 1054.63 732.277ZM1071.66 648.112C1065.64 678.428 1098.99 701.08 1124.96 684.315L1183.58 646.47C1199.5 636.195 1204.36 615.128 1194.55 598.93L1156.07 535.369C1139.52 508.046 1098.02 515.368 1091.8 546.707L1071.66 648.112Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.09 734.826C1054.09 734.825 1054.09 734.825 1054.09 734.825L956.311 516.094C946.568 494.298 961.035 469.349 984.796 466.971L1108.43 454.599C1109.11 454.538 1109.66 455.149 1109.53 455.821L1054.1 734.826C1054.1 734.83 1054.09 734.829 1054.09 734.826ZM1008.49 627.799C1022.41 658.938 1068.12 653.768 1074.77 620.302L1098.03 503.175C1102.61 480.119 1083.62 459.202 1060.23 461.547L987.837 468.804C964.077 471.186 949.614 496.134 959.359 517.928L1008.49 627.799Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1253.95 143.466C1253.76 144.286 1252.72 144.542 1252.17 143.903L1098.77 -35.9286L1098.55 -36.1865C1098.12 -36.6926 1098.38 -37.4727 1099.02 -37.6286C1099.12 -37.6509 1099.2 -37.6878 1099.28 -37.7379L1255.25 -134.619C1281.61 -150.99 1314.64 -127.53 1307.86 -97.256L1253.95 143.466ZM1206.95 87.6681C1225.67 109.616 1261.43 100.741 1267.73 72.5799L1304.79 -92.8761C1311.57 -123.151 1278.53 -146.611 1252.18 -130.238L1135.7 -57.88C1117.5 -46.5739 1113.63 -21.7231 1127.53 -5.43005L1206.95 87.6681Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M992.621 135.854C992.621 135.861 992.63 135.864 992.634 135.858L1098.5 -36.9404C1098.86 -37.5155 1099.67 -37.5788 1100.11 -37.0657L1203.78 84.1181C1223.56 107.238 1206.43 142.856 1176.01 141.859L992.628 135.848C992.624 135.847 992.621 135.851 992.621 135.854ZM1027.72 82.5525C1013.69 105.438 1029.57 134.934 1056.39 135.812L1171.31 139.576C1201.72 140.572 1218.85 104.958 1199.07 81.8375L1130.79 1.99843C1115.34 -16.0588 1086.77 -13.7911 1074.34 6.47761L1027.72 82.5525Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.76 455.932C1108.75 455.932 1108.74 455.933 1108.74 455.935L1108.64 455.959C1107.86 456.149 1107.2 455.351 1107.54 454.623L1229.85 192.511C1240.8 169.043 1272.55 165.165 1288.81 185.312L1407.94 332.971C1424.09 352.989 1413.84 383.016 1388.82 388.998L1108.79 455.929C1108.78 455.931 1108.77 455.932 1108.76 455.932ZM1110.42 453.321C1110.42 453.321 1110.42 453.315 1110.42 453.314L1386.67 387.282C1410.96 381.476 1420.91 352.333 1405.23 332.904L1289.27 189.164C1273.01 169.016 1241.26 172.894 1230.31 196.365L1110.42 453.319C1110.42 453.32 1110.42 453.321 1110.42 453.321Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.14 455.659C1108.75 456.471 1107.58 456.411 1107.28 455.563L994.146 135.604C993.892 134.891 994.436 134.147 995.192 134.172L1202.06 140.971C1227.14 141.795 1243.22 167.973 1232.62 190.725L1109.14 455.659ZM1079.81 371.746C1090.25 401.29 1131.29 403.252 1144.53 374.841L1229.4 192.766C1240.01 170.014 1223.93 143.835 1198.85 143.011L1047.86 138.053C1023.22 137.244 1005.48 161.476 1013.69 184.713L1079.81 371.746Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1476.04 552.725C1476.04 552.724 1476.04 552.723 1476.04 552.722L1108.47 456.186C1108.11 456.089 1107.83 455.794 1107.76 455.425L1107.75 455.366C1107.63 454.786 1107.99 454.217 1108.56 454.08L1441.17 374.769C1441.72 374.634 1442.27 374.987 1442.37 375.543L1476.04 552.725C1476.04 552.729 1476.04 552.728 1476.04 552.725ZM1473.41 549.788C1473.41 549.792 1473.4 549.792 1473.4 549.789L1443.59 392.858C1441.96 384.255 1433.47 378.763 1424.95 380.795L1249.03 422.75C1213.6 431.199 1213.01 481.398 1248.23 490.647L1473.41 549.786C1473.41 549.786 1473.41 549.787 1473.41 549.788Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.39 629.175C1213.39 629.172 1213.39 629.167 1213.39 629.163L1108.01 455.997C1107.51 455.174 1108.27 454.157 1109.2 454.402L1356.94 519.473C1391.25 528.485 1391.9 576.949 1357.85 586.916L1213.4 629.191C1213.39 629.194 1213.38 629.182 1213.39 629.175ZM1200.35 603.757C1208.58 617.283 1224.86 623.594 1240.06 619.145L1349.86 587.014C1383.92 577.049 1383.27 528.582 1348.96 519.571L1195.01 479.14C1164.56 471.142 1139.84 504.297 1156.2 531.195L1200.35 603.757Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1253.73 143.967C1253.73 143.974 1253.72 143.976 1253.72 143.97L1252.93 142.452C1252.85 142.281 1252.88 142.073 1253.03 141.944L1464.13 -48.822C1464.68 -49.3294 1465.57 -49.0615 1465.75 -48.3361L1485.55 32.6806C1489.88 50.3743 1479.91 68.4342 1462.62 74.2051L1253.73 143.961C1253.73 143.962 1253.73 143.964 1253.73 143.967ZM1382.02 28.1936C1353.88 53.618 1380.59 99.3664 1416.55 87.3524L1460.18 72.7789C1477.45 67.0072 1487.42 48.9523 1483.1 31.2616L1478.13 10.9064C1471.84 -14.8337 1440.34 -24.5067 1420.67 -6.7351L1382.02 28.1936Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1490.41 256.792C1489.99 285.644 1456.8 301.638 1433.98 283.985L1253.19 144.088C1252.49 143.546 1252.68 142.447 1253.52 142.167L1491.91 62.4708C1492.56 62.2566 1493.23 62.7509 1493.22 63.4404L1490.41 256.792ZM1432.01 279.812C1454.82 297.466 1488.01 281.47 1488.43 252.617L1490.44 114.323C1490.79 90.2146 1467.23 72.9926 1444.36 80.6404L1318.16 122.84C1291.62 131.715 1285.7 166.598 1307.82 183.717L1432.01 279.812Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.91 376.783C1440.91 376.792 1440.9 376.796 1440.9 376.789L1253.77 144.807C1253.41 144.365 1253.42 143.731 1253.8 143.303C1254.2 142.836 1254.9 142.767 1255.39 143.146L1489.18 323.973C1489.69 324.363 1489.75 325.105 1489.31 325.57L1440.92 376.776C1440.91 376.778 1440.91 376.78 1440.91 376.783ZM1419.63 347.118C1430.95 361.145 1452.04 361.966 1464.42 348.864C1476.52 336.07 1474.94 315.638 1461.02 304.872C1433.1 283.278 1397.47 319.648 1419.63 347.118Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1475.84 550.369C1475.81 550.927 1475.36 551.374 1474.81 551.417C1474.24 551.461 1473.72 551.068 1473.62 550.506L1440.74 375.507C1440.67 375.15 1440.78 374.78 1441.03 374.514L1448.39 366.656C1462.47 351.627 1487.62 362.485 1486.33 383.035L1475.84 550.369ZM1474.29 543.129C1474.29 543.129 1474.28 543.123 1474.28 543.116L1484.32 383.15C1485.5 364.436 1462.59 354.549 1449.77 368.237C1445.41 372.891 1443.53 379.342 1444.71 385.605L1474.31 543.114C1474.31 543.122 1474.3 543.129 1474.29 543.129Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M905.481 101.511C913.892 99.4858 919.178 90.6054 917.278 81.6721C915.377 72.7388 907.021 67.1301 898.61 69.1555C890.199 71.1808 884.913 80.0611 886.813 88.9944C888.714 97.9277 897.07 103.536 905.481 101.511Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M905.481 101.511C913.892 99.4858 919.178 90.6054 917.278 81.6721C915.377 72.7388 907.021 67.1301 898.61 69.1555C890.199 71.1808 884.913 80.0611 886.813 88.9944C888.714 97.9277 897.07 103.536 905.481 101.511Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M967.608 207.955C976.019 205.93 981.305 197.05 979.405 188.116C977.504 179.151 969.148 173.574 960.737 175.6C952.326 177.625 947.04 186.474 948.94 195.439C950.841 204.372 959.197 209.981 967.608 207.955Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M967.608 207.955C976.019 205.93 981.305 197.05 979.405 188.116C977.504 179.151 969.148 173.574 960.737 175.6C952.326 177.625 947.04 186.474 948.94 195.439C950.841 204.372 959.197 209.981 967.608 207.955Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M940.925 488.933C949.337 486.908 954.623 478.028 952.722 469.094C950.822 460.161 942.466 454.552 934.054 456.578C925.643 458.603 920.357 467.483 922.258 476.417C924.158 485.35 932.514 490.959 940.925 488.933Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M967.608 207.955C976.019 205.93 981.305 197.05 979.405 188.116C977.504 179.151 969.148 173.574 960.737 175.6C952.326 177.625 947.04 186.474 948.94 195.439C950.841 204.372 959.197 209.981 967.608 207.955Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M967.608 207.955C976.019 205.93 981.305 197.05 979.405 188.116C977.504 179.151 969.148 173.574 960.737 175.6C952.326 177.625 947.04 186.474 948.94 195.439C950.841 204.372 959.197 209.981 967.608 207.955Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M940.925 488.933C949.337 486.908 954.623 478.028 952.722 469.094C950.822 460.161 942.466 454.552 934.054 456.578C925.643 458.603 920.357 467.483 922.258 476.417C924.158 485.35 932.514 490.959 940.925 488.933Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M905.481 101.511C913.892 99.4858 919.178 90.6054 917.278 81.6721C915.377 72.7388 907.021 67.1301 898.61 69.1555C890.199 71.1808 884.913 80.0611 886.813 88.9944C888.714 97.9277 897.07 103.536 905.481 101.511Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M905.481 101.511C913.892 99.4858 919.178 90.6054 917.278 81.6721C915.377 72.7388 907.021 67.1301 898.61 69.1555C890.199 71.1808 884.913 80.0611 886.813 88.9944C888.714 97.9277 897.07 103.536 905.481 101.511Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M967.608 207.955C976.019 205.93 981.305 197.05 979.405 188.116C977.504 179.183 969.148 173.574 960.737 175.6C952.326 177.625 947.04 186.505 948.94 195.439C950.841 204.372 959.197 209.981 967.608 207.955Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M997.872 151.421C1006.28 149.396 1011.57 140.515 1009.67 131.582C1007.77 122.649 999.412 117.04 991.001 119.065C982.59 121.091 977.303 129.971 979.204 138.904C981.104 147.838 989.46 153.446 997.872 151.421Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M967.578 207.923C975.989 205.898 981.275 197.018 979.375 188.084C977.474 179.151 969.118 173.542 960.707 175.568C952.296 177.593 947.039 186.473 948.94 195.407C950.84 204.34 959.196 209.949 967.578 207.923Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M905.481 101.511C913.892 99.4858 919.178 90.6054 917.278 81.6721C915.377 72.7388 907.021 67.1301 898.61 69.1555C890.199 71.1808 884.913 80.0611 886.813 88.9944C888.714 97.9277 897.07 103.536 905.481 101.511Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M905.481 101.511C913.892 99.4858 919.178 90.6054 917.278 81.6721C915.377 72.7388 907.021 67.1301 898.61 69.1555C890.199 71.1808 884.913 80.0611 886.813 88.9944C888.714 97.9277 897.07 103.536 905.481 101.511Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M967.578 207.923C975.989 205.898 981.275 197.018 979.375 188.084C977.474 179.151 969.118 173.542 960.707 175.568C952.296 177.593 947.039 186.473 948.94 195.407C950.84 204.34 959.196 209.949 967.578 207.923Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M967.608 207.955C976.019 205.93 981.305 197.05 979.405 188.116C977.504 179.151 969.148 173.574 960.737 175.6C952.326 177.625 947.04 186.474 948.94 195.439C950.841 204.372 959.197 209.981 967.608 207.955Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M997.872 151.421C1006.28 149.396 1011.57 140.515 1009.67 131.582C1007.77 122.649 999.412 117.04 991.001 119.065C982.59 121.091 977.303 129.971 979.204 138.904C981.104 147.838 989.46 153.446 997.872 151.421Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.97 471.567C1120.38 469.541 1125.66 460.661 1123.76 451.728C1121.86 442.795 1113.51 437.186 1105.09 439.211C1096.68 441.237 1091.4 450.117 1093.3 459.05C1095.2 467.983 1103.55 473.592 1111.97 471.567Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M967.578 207.923C975.989 205.898 981.275 197.018 979.375 188.084C977.474 179.151 969.118 173.542 960.707 175.568C952.296 177.593 947.039 186.473 948.94 195.407C950.84 204.34 959.196 209.949 967.578 207.923Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M940.925 488.933C949.337 486.908 954.623 478.028 952.722 469.094C950.822 460.161 942.466 454.552 934.054 456.578C925.643 458.603 920.357 467.483 922.258 476.417C924.158 485.35 932.514 490.959 940.925 488.933Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M940.925 488.933C949.337 486.908 954.623 478.028 952.722 469.094C950.822 460.161 942.466 454.552 934.054 456.578C925.643 458.603 920.357 467.483 922.258 476.417C924.158 485.35 932.514 490.959 940.925 488.933Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.97 471.567C1120.38 469.541 1125.66 460.661 1123.76 451.728C1121.86 442.795 1113.51 437.186 1105.09 439.211C1096.68 441.237 1091.4 450.117 1093.3 459.05C1095.2 467.983 1103.55 473.592 1111.97 471.567Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M967.578 207.923C975.989 205.898 981.275 197.018 979.375 188.084C977.474 179.151 969.118 173.542 960.707 175.568C952.296 177.593 947.039 186.473 948.94 195.407C950.84 204.34 959.196 209.949 967.578 207.923Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.97 471.567C1120.38 469.541 1125.66 460.661 1123.76 451.728C1121.86 442.795 1113.51 437.186 1105.09 439.211C1096.68 441.237 1091.4 450.117 1093.3 459.05C1095.2 467.983 1103.55 473.592 1111.97 471.567Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M940.925 488.933C949.337 486.908 954.623 478.028 952.722 469.094C950.822 460.161 942.466 454.552 934.054 456.578C925.643 458.603 920.357 467.483 922.258 476.417C924.158 485.35 932.514 490.959 940.925 488.933Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M940.925 488.933C949.337 486.908 954.623 478.028 952.722 469.094C950.822 460.161 942.466 454.552 934.054 456.578C925.643 458.603 920.357 467.483 922.258 476.417C924.158 485.35 932.514 490.959 940.925 488.933Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.97 471.567C1120.38 469.541 1125.66 460.661 1123.76 451.728C1121.86 442.795 1113.51 437.186 1105.09 439.211C1096.68 441.237 1091.4 450.117 1093.3 459.05C1095.2 467.983 1103.55 473.592 1111.97 471.567Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.85 159.514C1265.27 157.489 1270.55 148.608 1268.65 139.675C1266.75 130.742 1258.39 125.133 1249.98 127.158C1241.57 129.184 1236.29 138.064 1238.19 146.997C1240.09 155.931 1248.44 161.539 1256.85 159.514Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M997.872 151.421C1006.28 149.396 1011.57 140.515 1009.67 131.582C1007.77 122.649 999.412 117.04 991.001 119.065C982.59 121.091 977.303 129.971 979.204 138.904C981.104 147.838 989.46 153.446 997.872 151.421Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M997.872 151.421C1006.28 149.396 1011.57 140.515 1009.67 131.582C1007.77 122.649 999.412 117.04 991.001 119.065C982.59 121.091 977.303 129.971 979.204 138.904C981.104 147.838 989.46 153.446 997.872 151.421Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.85 159.514C1265.27 157.489 1270.55 148.608 1268.65 139.675C1266.75 130.742 1258.39 125.133 1249.98 127.158C1241.57 129.184 1236.29 138.064 1238.19 146.997C1240.09 155.931 1248.44 161.539 1256.85 159.514Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.97 471.567C1120.38 469.541 1125.66 460.661 1123.76 451.728C1121.86 442.795 1113.51 437.186 1105.09 439.211C1096.68 441.237 1091.4 450.117 1093.3 459.05C1095.2 467.983 1103.55 473.592 1111.97 471.567Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.84 159.514C1256.85 159.514 1256.86 159.513 1256.87 159.51C1265.27 157.478 1270.55 148.603 1268.65 139.675C1266.75 130.741 1258.39 125.133 1249.98 127.158C1241.57 129.183 1236.32 138.064 1238.19 146.997C1240.09 155.925 1248.43 161.533 1256.81 159.517C1256.82 159.515 1256.83 159.514 1256.84 159.514Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.97 471.567C1120.38 469.541 1125.66 460.661 1123.76 451.728C1121.86 442.795 1113.51 437.217 1105.09 439.243C1096.68 441.268 1091.4 450.117 1093.3 459.05C1095.2 467.983 1103.55 473.592 1111.97 471.567Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M997.872 151.421C1006.28 149.396 1011.57 140.515 1009.67 131.582C1007.77 122.649 999.412 117.04 991.001 119.065C982.59 121.091 977.303 129.971 979.204 138.904C981.104 147.838 989.46 153.446 997.872 151.421Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M997.872 151.421C1006.28 149.396 1011.57 140.515 1009.67 131.582C1007.77 122.649 999.412 117.04 991.001 119.065C982.59 121.091 977.303 129.971 979.204 138.904C981.104 147.838 989.46 153.446 997.872 151.421Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.84 159.514C1256.85 159.514 1256.86 159.513 1256.87 159.51C1265.27 157.478 1270.55 148.603 1268.65 139.675C1266.75 130.741 1258.39 125.133 1249.98 127.158C1241.57 129.183 1236.32 138.064 1238.19 146.997C1240.09 155.925 1248.43 161.533 1256.81 159.517C1256.82 159.515 1256.83 159.514 1256.84 159.514Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.97 471.567C1120.38 469.541 1125.66 460.661 1123.76 451.728C1121.86 442.795 1113.51 437.217 1105.09 439.243C1096.68 441.268 1091.4 450.117 1093.3 459.05C1095.2 467.983 1103.55 473.592 1111.97 471.567Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.97 471.567C1120.38 469.541 1125.66 460.661 1123.76 451.728C1121.86 442.795 1113.51 437.186 1105.09 439.211C1096.68 441.237 1091.4 450.117 1093.3 459.05C1095.2 467.983 1103.55 473.592 1111.97 471.567Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.97 471.567C1120.38 469.541 1125.66 460.661 1123.76 451.728C1121.86 442.795 1113.51 437.217 1105.09 439.243C1096.68 441.268 1091.4 450.117 1093.3 459.05C1095.2 467.983 1103.55 473.592 1111.97 471.567Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.97 471.567C1120.38 469.541 1125.66 460.661 1123.76 451.728C1121.86 442.795 1113.51 437.217 1105.09 439.243C1096.68 441.268 1091.4 450.117 1093.3 459.05C1095.2 467.983 1103.55 473.592 1111.97 471.567Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.85 159.514C1265.27 157.489 1270.55 148.608 1268.65 139.675C1266.75 130.742 1258.39 125.133 1249.98 127.158C1241.57 129.184 1236.29 138.064 1238.19 146.997C1240.09 155.931 1248.44 161.539 1256.85 159.514Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.85 159.514C1265.27 157.489 1270.55 148.608 1268.65 139.675C1266.75 130.742 1258.39 125.133 1249.98 127.158C1241.57 129.184 1236.29 138.064 1238.19 146.997C1240.09 155.931 1248.44 161.539 1256.85 159.514Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.85 159.514C1265.27 157.489 1270.55 148.608 1268.65 139.675C1266.75 130.742 1258.39 125.133 1249.98 127.158C1241.57 129.184 1236.29 138.064 1238.19 146.997C1240.09 155.931 1248.44 161.539 1256.85 159.514Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.85 159.514C1265.27 157.489 1270.55 148.608 1268.65 139.675C1266.75 130.742 1258.39 125.133 1249.98 127.158C1241.57 129.184 1236.29 138.064 1238.19 146.997C1240.09 155.931 1248.44 161.539 1256.85 159.514Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.85 159.514C1265.27 157.489 1270.55 148.608 1268.65 139.675C1266.75 130.742 1258.39 125.133 1249.98 127.158C1241.57 129.184 1236.29 138.064 1238.19 146.997C1240.09 155.931 1248.44 161.539 1256.85 159.514Z",
    fill: "#076AFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.85 159.514C1265.27 157.489 1270.55 148.608 1268.65 139.675C1266.75 130.742 1258.39 125.133 1249.98 127.158C1241.57 129.184 1236.29 138.064 1238.19 146.997C1240.09 155.931 1248.44 161.539 1256.85 159.514Z",
    fill: "#076AFF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_1323",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1122.4 -488.641) rotate(-89.856) scale(1318.75 1241.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#000B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_1323",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4434 -35.9636) rotate(-89.856) scale(1250.48 1177.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#11ADF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0865A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#001543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000020"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_1323",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1560.79 117.432) rotate(-89.856) scale(1617.01 928.829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0084CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0081C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#005F92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#004265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#002A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#001724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#000A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#000204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame12);
export default __webpack_public_path__ + "static/media/Frame 12.f6b6d4f82ae56d708f55efdbb132711c.svg";
export { ForwardRef as ReactComponent };